module.exports = __webpack_public_path__ + "img/Geringfügig_erhöhte_Aktivität.b4e88319.svg";